import ContentContainer from "./ContentContainer";
import Section from "./Section";
import SectionText from "./SectionText";
import SectionTitle from "./SectionTitle";
import classes from "../../scss/ServiceDescription.module.scss";

const Description = ({ text, title }) => {
  return (
    <Section className={classes.description}>
      <ContentContainer>
        <div className={classes.description__body}>
          <SectionTitle title={title} className={classes.description__title} />
          <SectionText text={text} className={classes.description__text} />
        </div>
      </ContentContainer>
    </Section>
  );
};

export default Description;
